// @module eComm.SegmentationExtension.SegmentationExtension
define('Group.CartDetailed.View'
,	[
		'Cart.Detailed.View'
	,	'Backbone.CollectionView'
	,	'Cart.Lines.Free.View'
	,	'Cart.Lines.View'
	,	'Cart.Summary.View'
	,	'Cart.Item.Summary.View'
	,	'Cart.Item.Actions.View'
	,	'jQuery'
	,	'Backbone'
	,	'underscore'
	]
,	function (
		CartDetailedView
	,	BackboneCollectionView
	,	CartLinesFreeView
	,	CartLinesView
	,	CartSummaryView
	,	CartItemSummaryView
	,	CartItemActionsView
	,	jQuery
	,	Backbone
	,	_
	)
{
	'use strict';

	_.extend(CartDetailedView.prototype, {
		childViews: {
			'Cart.Summary': function() {
				return new CartSummaryView({
					model: this.model,
					showEstimated: this.showEstimated,
					application: this.application
				});
			},
			'Item.ListNavigable': function() {
				var lines = _.filter(this.model.get('lines').models || [], function(line){
					return line.get('free_gift') !== true;
				});
				// console.log('lines', lines);
				var lineidSet = [];
				var newLines = [];
				_.each(lines, function(line) {
					if (!line.id) return;
					var lineid = line.id.split('set');
					lineidSet.push('set'+lineid[1]);
				  });
				  if (lineidSet.length > 0) {
					lineidSet = _.sortBy(lineidSet, function (name) {return name});
					_.each(lineidSet, function(lineset){
					  _.each(lines, function(line){
						if (!line.id) return;
						if (line.id.includes(lineset)) {
						  newLines.push(line);
						}
					  });
					});
				  } else {
					newLines = lines;
				  }
				
				return new BackboneCollectionView({
					collection: newLines,
					viewsPerRow: 1,
					childView: CartLinesView,
					childViewOptions: {
						navigable: true,
						application: this.application,
						SummaryView: CartItemSummaryView,
						ActionsView: CartItemActionsView,
						showAlert: false
					}
				});
			},
	
			'Promocode.Notifications': function() {
				const promotions = _.filter(this.model.get('promocodes') || [], function(promocode) {
					return promocode.notification === true;
				});
	
				if (promotions.length) {
					return new BackboneCollectionView({
						collection: promotions,
						viewsPerRow: 1,
						childView: CartPromocodeNotifications,
						childViewOptions: {
							parentModel: this.model
						}
					});
				}
			},
	
			'Item.FreeGift': function() {
				const free_gifts = _.filter(this.model.get('lines').models || [], function(line) {
					return line.get('free_gift') === true;
				});
	
				if (free_gifts.length) {
					return new BackboneCollectionView({
						collection: free_gifts,
						viewsPerRow: 1,
						childView: CartLinesFreeView,
						childViewOptions: {
							navigable: true
						}
					});
				}
			},
	
			'FreeGift.Info': function() {
				let message;
				const free_gifts = _.filter(this.model.get('lines').models || [], function(line) {
					return line.get('free_gift') === true;
				});
	
				if (free_gifts.length === 1) {
					message = Utils.translate(
						'The following item is free but it may generate shipping costs.'
					);
				} else if (free_gifts.length > 1) {
					message = Utils.translate(
						'The following items are free but they may generate shipping costs.'
					);
				}
	
				if (message) {
					return new GlobalViewsMessageView({
						message: message,
						type: 'info',
						closable: false
					});
				}
			}
		}
	})
	
});
